/**
 * External dependencies
 */
import inherits from 'inherits';

export default class KioskPlan {
    
    constructor(cscom) {
        if (!(this instanceof KioskPlan)) {
            return new KioskPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/kiosk-plans/list', null, data);
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/kiosk-plans/view', null, data);
    }    
}
